export const formatDisplayValue = (
  type: React.HTMLInputTypeAttribute | undefined,
  value: string | number | undefined,
): string => {
  if (value === undefined) return ''
  if (type === 'number' || type === 'range') return String(Number(value))
  return String(value)
}
